module.exports = __webpack_public_path__ + "img/[666].cf7193cc.svg";